export const getSilentInfo = (paramKey: any, defaultVal: any) => {
  if (sessionStorage.getItem('silentPayload')) {
    try {
      const saPayload = sessionStorage.getItem('silentPayload');
      const payload = JSON.parse(atob(saPayload));
      if (paramKey === 'analytics') {
        const requiredConfig = {
          analytics: [
            {
              key: '',
              name: '',
            },
          ],
        };
        requiredConfig.analytics[0].key = payload[paramKey].key;
        requiredConfig.analytics[0].name = payload[paramKey].id;
        return requiredConfig;
      }
      if (payload[paramKey]) {
        return { [paramKey]: payload[paramKey] };
      }
    } catch (error) {
      return { ...defaultVal };
    }
  }
  return { ...defaultVal };
};
